import React from 'react';
import { motion } from 'framer-motion';
import { CountdownTimer } from './CountdownTimer';
import { PricingCard } from './PricingCard';
export function CtaFinal() {
  return <section id="cta-final" className="bg-navy py-[60px] md:py-[80px] text-center relative overflow-hidden glow-bg-gold" data-id="element-96">
      <div className="max-w-[900px] mx-auto px-5 relative z-10" data-id="element-97">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-[clamp(28px,5vw,44px)] font-black leading-[1.2] mb-4" data-id="element-98">
          El próximo parcial puede ser diferente.
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-[17px] text-brand-gray max-w-[480px] mx-auto mb-8 leading-[1.7]" data-id="element-99">
          No porque estudiés más. Sino porque estudiás mejor.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="mb-10" data-id="element-100">
          <CountdownTimer data-id="element-101" />
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 items-center text-left mb-10" data-id="element-102">
          <PricingCard icon="📘" title="SISTEMA IA UNIVERSITARIO" features="" oldPrice="~~$38.000~~" newPrice="$19.990 ARS" buttonText="→ QUIERO EL SISTEMA AHORA" href="https://librofy-store.myshopify.com/cart/47909760106717:1" delay={0} data-id="element-103" />
          <PricingCard icon="🏆" title="SISTEMA IA + MENTORÍA" features="" oldPrice="~~$55.000~~" newPrice="$27.990 ARS" buttonText="→ QUIERO SISTEMA + MENTORÍA" href="https://librofy-store.myshopify.com/checkouts/cn/hWNDC2YhgQFxT6QjxhxL0tCE/es-ar?_r=AQABaMWEh2_MnS_qSPgGn5hiRubNit4fMT9glsLEWa7PKZs&cart_link_id=Sy4dIPgn&preview_theme_id=160306823389" highlighted={true} delay={0.1} data-id="element-104" />
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="flex justify-center flex-wrap gap-x-4 gap-y-2 mt-5 text-[13px] text-brand-gray font-medium" data-id="element-105">
          <span className="flex items-center gap-1.5" data-id="element-106">🔒 Pago 100% seguro</span>
          <span className="flex items-center gap-1.5" data-id="element-107">
            ⚡ Acceso en 5 minutos
          </span>
          <span className="flex items-center gap-1.5" data-id="element-108">🛡️ Garantía 7 días</span>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3
      }} className="flex justify-center mt-3 text-[13px] text-brand-gray font-medium" data-id="element-109">
          <span className="flex items-center gap-1.5" data-id="element-110">
            💳 Mercado Pago | Tarjeta | Transferencia
          </span>
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="mt-10 text-[clamp(18px,3vw,22px)] font-black text-brand-gold text-center" data-id="element-111">
          "El próximo cuatrimestre puede ser diferente."
        </motion.p>
      </div>
    </section>;
}